import classNames from "classnames/bind";
import * as React from "react";
import styles from "./Typography.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  small?: boolean;
  uppercase?: boolean;
  center?: boolean;
  withSpacing?: boolean;
}

const getClassNames = (
  {
    small = false,
    uppercase = false,
    center = false,
    withSpacing = true,
  }: Omit<Props, "children">,
  extraClassName?: string,
) =>
  `${classNameBuilder({
    text: true,
    uppercase,
    center,
    withSpacing,
    small,
  })}${extraClassName ? ` ${extraClassName}` : ""}`;

export const H1: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <h1 className={getClassNames(props, styles.h1)}>{children}</h1>;

export const H2: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <h2 className={getClassNames(props, styles.h2)}>{children}</h2>;

export const H3: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <h3 className={getClassNames(props, styles.h3)}>{children}</h3>;

export const H4: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <h4 className={getClassNames(props, styles.h4)}>{children}</h4>;

export const H5: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <h5 className={getClassNames(props, styles.h5)}>{children}</h5>;

export const Paragraph: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <p className={getClassNames(props, styles.paragraph)}>{children}</p>;

export const SubText: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => <p className={getClassNames(props, styles.subtext)}>{children}</p>;
